
import generateParseObject from "./common/parse/ParseObjectFactory";
import {toJSONList,toJSON} from "./common/parse/helper/parse";
import * as  axios from "axios";
const Settings = generateParseObject("v5_settings");
const getData = (resp) => resp.data;

export default class SettingsService {

    static  getSettings(){
        return Settings.read()
    }

    static update(settings){
        return axios.post('/teacher/setting/update',settings).then(getData)
    }

}